module.exports = __webpack_public_path__ + "static/media/15.2967d27c.jpg";